import { Streams } from "@graylog/server-api";
import { SigmaRepositories } from "@graylog/enterprise-api";
import { qualifyUrl } from "util/URLUtils";
import EnterpriseApiRoutes from "common/ApiRoutes";
import fetch from "logic/rest/FetchProvider";
export const fetchStreams = async () => Streams.get();
export const fetchNotifications = async () => fetch("GET", qualifyUrl("events/notifications"));
export const addGitRepo = async ({ repo }) => fetch("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.sigmaGitRepos().url), repo);
export const addDefaultRepo = async () => SigmaRepositories.createDefault();
export const updateGitRepo = async ({ repoId = void 0, repo }) => fetch("PUT", qualifyUrl(EnterpriseApiRoutes.SecurityApp.sigmaGitRepo(repoId).url), repo);
export const deleteSigmaRepo = async ({ repoId }) => SigmaRepositories.deleteRepo(repoId);
export const listRepoContent = async (repoId, path = "", query = "") => fetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.sigmaGitRepo(repoId, path, query).url));
export const importAllRulesFromRepo = async (payload) => fetch("PUT", qualifyUrl(EnterpriseApiRoutes.SecurityApp.importAllRules().url), payload);
export const refreshRepoRules = async ({ repoId }) => SigmaRepositories.refreshRepo(repoId);
export const bulkSigmaRepoDelete = async (ids) => SigmaRepositories.bulkDeleteRepos({ ids });
export const listGitRepos = async (page, perPage, query = null, orderBy = "name", direction = "asc") => {
  const options = [`page=${page}`, `per_page=${perPage}`];
  if (query) options.push(`query=${query}`);
  if (orderBy) options.push(`sort=${orderBy}`);
  if (direction) options.push(`direction=${direction}`);
  return fetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.allSigmaRepos(options.join("&")).url));
};
export const validateSigmaRuleZip = async (file) => {
  const formData = new FormData();
  const http = new XMLHttpRequest();
  formData.append("file", file);
  return new Promise((resolve, reject) => {
    http.onreadystatechange = () => {
      var _a, _b;
      if (http.readyState === 4) {
        if (http.status === 200) {
          resolve(JSON.parse(http.response));
        } else {
          const errorMessage = (_b = (_a = JSON.parse(http.responseText)) == null ? void 0 : _a.message) != null ? _b : http.statusText;
          reject(new Error(errorMessage));
        }
      }
    };
    http.open("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.validateSigmaRuleZip().url), true);
    http.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    http.setRequestHeader("X-Requested-By", "XMLHttpRequest");
    http.send(formData);
  });
};
export const validateSigmaRuleYaml = async (files) => {
  const formData = new FormData();
  const http = new XMLHttpRequest();
  files.forEach((file) => {
    formData.append("files", file, file.name);
  });
  return new Promise((resolve, reject) => {
    http.onreadystatechange = () => {
      var _a, _b;
      if (http.readyState === 4) {
        if (http.status === 200) {
          resolve(JSON.parse(http.response));
        } else {
          const errorMessage = (_b = (_a = JSON.parse(http.responseText)) == null ? void 0 : _a.message) != null ? _b : http.statusText;
          reject(new Error(errorMessage));
        }
      }
    };
    http.open("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.validateSigmaRuleYaml().url), true);
    http.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    http.setRequestHeader("X-Requested-By", "XMLHttpRequest");
    http.send(formData);
  });
};
export const bulkImportFromRepo = async (payload) => fetch("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.sigmaImportBulkFromRepo().url), payload);
export const bulkUploadEventDefs = async ({
  files,
  file_overrides,
  share_request,
  progressCB
}) => {
  const formData = new FormData();
  const http = new XMLHttpRequest();
  files.forEach((file) => {
    formData.append("files", file, file.name);
  });
  const requestBody = { entity: { file_overrides }, share_request };
  formData.append("request", new Blob([JSON.stringify(requestBody)], { type: "application/json" }));
  return new Promise((resolve, reject) => {
    if (progressCB) {
      http.upload.onprogress = ({ loaded, total }) => {
        progressCB(Math.ceil(loaded * 100 / total));
      };
    }
    http.onreadystatechange = () => {
      var _a, _b;
      if (http.readyState === 4) {
        if (http.status === 200) {
          resolve(JSON.parse(http.response));
        } else {
          const errorMessage = (_b = (_a = JSON.parse(http.responseText)) == null ? void 0 : _a.message) != null ? _b : http.statusText;
          reject(new Error(errorMessage));
        }
      }
    };
    http.open("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.sigmaImportBulkUpload().url), true);
    http.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    http.setRequestHeader("X-Requested-By", "XMLHttpRequest");
    http.send(formData);
  });
};
